import {Badge} from '@sail/ui';
import {useIntl} from '@sail/intl';
import messages from 'src/utils/messages';

export const TestmodeBadge = () => {
  const intl = useIntl();

  return (
    <Badge type="warning">
      {intl.formatMessage(messages.testmodeBadgeLabel)}{' '}
    </Badge>
  );
};
